export default __webpack_public_path__ + "static/media/new-course-Courses.0576d208.jpg";